import { render, staticRenderFns } from "./CmfPickupStep6.vue?vue&type=template&id=489fe745&scoped=true"
import script from "./CmfPickupStep6.vue?vue&type=script&lang=js"
export * from "./CmfPickupStep6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489fe745",
  null
  
)

export default component.exports